import React, { useContext } from 'react';
import { userContext } from './ApiFetchContext';
import '../styles/MoreBusiness.css';
import Navbar from './NavBar';
import { useNavigate } from 'react-router-dom';

const MoreBusiness = () => {
  const {businessData} = useContext(userContext);
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <div style={{height:"60px", backgroundColor:"#3498db"}}></div>
      <div className="more-mentors-container">
        <h2>All Business</h2>
        <div className="mentor-cards">
          {businessData && businessData.length > 0 ? (
            businessData.map((b) => (
              <div key={b.id} className="mentor-card"
              onClick={() => navigate(`/user/${b.id}`)}>
                {/* <div className="mentor-card-header">
                  <img
                    src={user.image || 'https://kitezone.in/images/users/user_pic_1725948652.png'}
                    alt={user.name || 'No Name'}
                    className="mentor-card-img"
                  />
                </div> */}
                <div className="mentor-card-info">
                  <h3>{b.name || 'Name Not Available'}</h3>
                  <p>
                    {b.email ? (
                      <a href={`mailto:${b.email}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        {b.email}
                      </a>
                    ) : (
                      'Email Not Available'
                    )}
                  </p>
                  {/* <p>
                    {user.phone ? (
                      <a
                        href={`https://wa.me/${user.phone}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        {user.phone}
                      </a>
                    ) : (
                      'Phone Not Available'
                    )}
                  </p> */}
                  <p>{b.category || 'Description Not Available'}</p>
                </div>
              </div>
            ))
          ) : (
            <p>Loading data.......</p>
          )}
        </div>
      </div>
    </>
  );
};

export default MoreBusiness;